var _dec, _class, _temp;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//@ts-nocheck

/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import React from 'react';
import { View } from 'react-native';
import { FalsyFC, RTLService } from "../../devsupport";
import { styled } from "../../theme";
import { PopoverPlacements } from "./type";
const INDICATOR_OFFSET = 8;
const INDICATOR_WIDTH = 6;
export let PopoverView = (_dec = styled('Popover'), _dec(_class = (_temp = class PopoverView extends React.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "getComponentStyle", source => {
      const {
        indicatorWidth,
        indicatorHeight,
        indicatorBackgroundColor
      } = source,
            containerParameters = _objectWithoutProperties(source, ["indicatorWidth", "indicatorHeight", "indicatorBackgroundColor"]);

      return {
        content: containerParameters,
        indicator: {
          width: indicatorWidth,
          height: indicatorHeight,
          backgroundColor: indicatorBackgroundColor
        }
      };
    });

    _defineProperty(this, "getDirectionStyle", () => {
      const {
        direction,
        alignment
      } = this.placement.flex();
      const isVertical = direction.startsWith('column');
      const isStart = alignment.endsWith('start');
      const isEnd = alignment.endsWith('end');
      const isReverse = direction.endsWith('reverse'); // Rotate indicator by 90 deg if we have `row` direction (left/right placement)
      // Rotate it again by 180 if we have `row-reverse` (bottom/right placement)

      const indicatorRotate = isVertical ? 180 : 90;
      const indicatorReverseRotate = isReverse ? 0 : 180; // Translate container by half of `indicatorWidth`. Exactly half (because it has a square shape)
      // Reverse if needed
      // @ts-ignore: indicatorWidth type is always number

      let containerTranslate = this.props.indicator && !isVertical ? INDICATOR_WIDTH / 2 : 0;
      containerTranslate = isReverse ? containerTranslate : -containerTranslate; // Translate indicator by passed `indicatorOffset`
      // Reverse if needed

      let indicatorTranslate = isVertical ? -INDICATOR_OFFSET : INDICATOR_OFFSET;
      indicatorTranslate = isReverse ? -indicatorTranslate : indicatorTranslate;
      const i18nVerticalIndicatorTranslate = RTLService.select(indicatorTranslate, -indicatorTranslate);
      indicatorTranslate = isVertical ? i18nVerticalIndicatorTranslate : indicatorTranslate;
      const contentTransforms = {
        transform: [{
          translateX: containerTranslate
        }]
      };
      const indicatorTransforms = {
        transform: [{
          rotate: `${indicatorRotate}deg`
        }, {
          rotate: `${indicatorReverseRotate}deg`
        }, // Translate indicator "to start" if we have `-start` alignment
        // Or translate it "to end" if we have `-end` alignment
        {
          translateX: isStart ? -indicatorTranslate : 0
        }, {
          translateX: isEnd ? indicatorTranslate : 0
        }]
      };
      return {
        container: {
          flexDirection: direction,
          alignItems: alignment
        },
        content: contentTransforms,
        indicator: indicatorTransforms
      };
    });
  }

  get placement() {
    return PopoverPlacements.parse(this.props.placement);
  }

  render() {
    const _this$props = this.props,
          {
      eva,
      style,
      contentContainerStyle,
      onLayout,
      indicator
    } = _this$props,
          viewProps = _objectWithoutProperties(_this$props, ["eva", "style", "contentContainerStyle", "onLayout", "indicator"]);

    const evaStyle = this.getComponentStyle(eva.style);
    const directionStyle = this.getDirectionStyle();
    return /*#__PURE__*/React.createElement(View, {
      style: [directionStyle.container, contentContainerStyle],
      onLayout: onLayout
    }, /*#__PURE__*/React.createElement(FalsyFC, {
      style: [evaStyle.indicator, directionStyle.indicator],
      component: indicator
    }), /*#__PURE__*/React.createElement(View, _extends({}, viewProps, {
      style: [evaStyle.content, directionStyle.content, style]
    })));
  }

}, _temp)) || _class);